var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_027-sphere",
    "data-name": "027-sphere",
    transform: "translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M116.85,77.813a1.592,1.592,0,0,1-.855-.249c-1.247-.791-2.341-2.372-3.253-4.7a1.6,1.6,0,0,1,2.98-1.167c.9,2.288,1.688,2.976,1.987,3.166a1.6,1.6,0,0,1-.858,2.951Zm3.848-1.726a1.6,1.6,0,0,1-1.362-2.437,17,17,0,0,0,1.639-4.036,1.6,1.6,0,1,1,3.076.884,19.868,19.868,0,0,1-1.987,4.826A1.6,1.6,0,0,1,120.7,76.087Zm-7.807-6.814a1.6,1.6,0,0,1-1.562-1.262c-.326-1.51-.6-3.152-.808-4.881a1.6,1.6,0,0,1,3.177-.386c.2,1.632.454,3.177.76,4.591a1.6,1.6,0,0,1-1.226,1.9,1.631,1.631,0,0,1-.339.036Zm10.655-2.3a1.6,1.6,0,0,1-1.58-1.861c.241-1.462.434-3.023.572-4.64a1.6,1.6,0,0,1,3.188.273c-.145,1.7-.348,3.345-.6,4.889A1.6,1.6,0,0,1,123.546,66.969ZM111.7,59.754a1.6,1.6,0,0,1-1.6-1.518c-.068-1.332-.1-2.7-.1-4.063q0-.419,0-.835a1.6,1.6,0,1,1,3.2.032q0,.4,0,.8c0,1.31.033,2.622.1,3.9a1.6,1.6,0,0,1-1.516,1.68Zm12.684-2.343h-.034a1.6,1.6,0,0,1-1.567-1.633c.011-.531.016-1.071.016-1.6,0-1.584-.048-3.165-.144-4.7a1.6,1.6,0,0,1,3.194-.2c.1,1.6.15,3.247.15,4.9,0,.556-.006,1.118-.017,1.671a1.6,1.6,0,0,1-1.6,1.567ZM111.8,50.157c-.04,0-.079,0-.119,0a1.6,1.6,0,0,1-1.478-1.713c.125-1.691.306-3.336.539-4.891a1.6,1.6,0,1,1,3.165.474c-.221,1.476-.393,3.041-.512,4.653A1.6,1.6,0,0,1,111.8,50.157ZM123.785,46.2A1.6,1.6,0,0,1,122.2,44.81c-.222-1.638-.5-3.175-.832-4.568a1.6,1.6,0,1,1,3.114-.739c.354,1.494.654,3.135.889,4.877a1.6,1.6,0,0,1-1.371,1.8,1.631,1.631,0,0,1-.217.015Zm-10.514-5.517a1.6,1.6,0,0,1-1.549-2,23.868,23.868,0,0,1,1.754-4.836,1.6,1.6,0,0,1,2.845,1.465,20.724,20.724,0,0,0-1.5,4.178,1.6,1.6,0,0,1-1.547,1.2Zm8.183-3.769a1.6,1.6,0,0,1-1.463-.95c-1.035-2.326-1.84-2.562-1.928-2.581a1.6,1.6,0,0,1,.68-3.127c1.625.353,3.028,1.836,4.172,4.407a1.6,1.6,0,0,1-1.461,2.251Z",
    transform: "translate(-64 -0.172)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M54,30A24,24,0,1,0,78,54,24.027,24.027,0,0,0,54,30ZM64.4,72.005a1.6,1.6,0,0,0-2.582-.571,14.273,14.273,0,0,1-1.674,1.357,1.6,1.6,0,0,0-.69,1.28,20.83,20.83,0,0,1-11.048-.035,1.6,1.6,0,0,0-.677-1.327,14.42,14.42,0,0,1-1.661-1.375,1.6,1.6,0,0,0-2.607.594,20.781,20.781,0,0,1-2.444-34.17c-.049.073-.1.144-.147.217a1.6,1.6,0,1,0,2.676,1.755,18.782,18.782,0,0,1,1.316-1.775,1.594,1.594,0,0,0-.436-2.42,20.766,20.766,0,0,1,19.14,0,1.595,1.595,0,0,0-.437,2.42,18.768,18.768,0,0,1,1.316,1.774,1.6,1.6,0,0,0,2.676-1.755c-.048-.073-.1-.145-.147-.218A20.783,20.783,0,0,1,64.4,72.005Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M73.408,192.8a1.6,1.6,0,0,0-3.016,1.07,26.6,26.6,0,0,0,1.908,4.206,1.6,1.6,0,0,0,2.785-1.576,23.379,23.379,0,0,1-1.677-3.7Z",
    transform: "translate(-32.24 -129.388)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M64.12,149.5a1.6,1.6,0,0,0,1.363-1.806,29.763,29.763,0,0,1-.283-4.1v-.006a1.6,1.6,0,1,0-3.2.006,32.946,32.946,0,0,0,.314,4.548,1.6,1.6,0,0,0,1.583,1.379A1.66,1.66,0,0,0,64.12,149.5Z",
    transform: "translate(-25.6 -89.589)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M65.977,99.572a1.6,1.6,0,0,0,1.87-1.274,26.8,26.8,0,0,1,1.065-3.954A1.6,1.6,0,0,0,65.9,93.273,29.94,29.94,0,0,0,64.7,97.7,1.6,1.6,0,0,0,65.977,99.572Z",
    transform: "translate(-27.74 -49.766)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M222.356,142.348h0a1.6,1.6,0,0,0-1.6,1.6,29.715,29.715,0,0,1-.3,4.127,1.6,1.6,0,1,0,3.168.453,32.975,32.975,0,0,0,.327-4.573A1.6,1.6,0,0,0,222.356,142.348Z",
    transform: "translate(-152.353 -89.878)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M208.355,192.392a1.6,1.6,0,0,0-2.047.964,23.27,23.27,0,0,1-1.7,3.706,1.6,1.6,0,1,0,2.775,1.593,26.491,26.491,0,0,0,1.938-4.216A1.6,1.6,0,0,0,208.355,192.392Z",
    transform: "translate(-139.515 -129.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M214.885,98.455a1.6,1.6,0,0,0,3.145-.592,30.034,30.034,0,0,0-1.192-4.45,1.6,1.6,0,0,0-3.017,1.067A26.824,26.824,0,0,1,214.885,98.455Z",
    transform: "translate(-146.983 -49.877)",
    fill: "#727272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature_1.52306d0924f38ba9e0d61f2395cc1fe3.svg";
export { ForwardRef as ReactComponent };